import React from "react";
import styled, { createGlobalStyle } from "styled-components/macro";
import { BrowserRouter as Router, Link } from "react-router-dom";
import GlobalStyle from "../Styles/globalStyle";

const country = history => {
  const LocationStyle = createGlobalStyle`
  body{

    background: #005fb2;
    display: flex;
    justify-content: center;
    align-items: center;

    height: 100vh;

    @media (max-width: 500px) {
      background: none;
    }

  }
    `;

  const clickHandler = country => {
    localStorage.setItem("Country", country);
    this.forceUpdate();
  };
  return (
    <>
      <GlobalStyle />
      <LocationStyle />
      <MainWrapper>
        <h2>Where are you from?</h2>
        <Router>
          <Link
            to={history.location.pathname}
            onClick={country => clickHandler("USA")}
          >
            <img
              src="https://cdn.wihatoolsus.com/flags/usa.png"
              alt="United States of America"
            />
          </Link>
        </Router>
        <Link
          to={history.location.pathname}
          onClick={country => clickHandler("Canada")}
        >
          <img
            src="https://cdn.wihatoolsus.com/flags/canada.png"
            alt="Canada"
          />
        </Link>
      </MainWrapper>
    </>
  );
};

export default country;

const MainWrapper = styled.div`
  background: #fff;
  text-align: center;

  display: block;
  box-shadow: 0 0 10px 10px rgba(0, 0, 0, 0.2);

  padding: 2rem;

  img {
    margin: 0 1rem;
  }

  @media (max-width: 500px) {
    box-shadow: none;
  }
`;
